import { UserFabric } from '../../context/query';
import { Fabric } from '../../redux/types';

export function toFabricObject(fabric: UserFabric): Fabric {
  const id = fabric._id;
  let executionUrl = '';
  try {
    const clusterInfo = JSON.parse(fabric.cluster[0].AspectValue);
    executionUrl = clusterInfo.executionUrl || clusterInfo.urls.execution;
  } catch (e) {
    // ignore the error here, will show error only when that fabric is selected.
  }

  const aspects = fabric.aspects.reduce(
    (agg, { AspectName, AspectValue }) => {
      agg[AspectName] = JSON.parse(AspectValue);
      return agg;
    },
    {} as Record<string, object>
  );
  return {
    ...fabric,
    ...aspects,
    id,
    executionUrl
  };
}
